export default __webpack_public_path__ + "static/media/modal9.9a074e37.png";